module.exports = __webpack_public_path__ + "img/dong2.a74a8be1.gif";